import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { isChunkLoadError, reloadOnceForNewBuild } from "@/lib/lazyWithReload";

const RouteErrorFallback = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  // Log full error to console for debugging (never shown to user)
  // eslint-disable-next-line no-console
  console.error("Route error:", error);

  // A tab left open across a release fails to load the new page files.
  // Reload once so it picks up the current version instead of showing this.
  if (isChunkLoadError(error) && reloadOnceForNewBuild()) {
    return null;
  }


  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "Something went wrong";

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-6">
      <div className="max-w-md w-full text-center space-y-6 bg-card border border-border rounded-lg p-8 shadow-sm">
        <div className="mx-auto w-12 h-12 rounded-full bg-warning/10 flex items-center justify-center">
          <AlertTriangle className="w-6 h-6 text-warning" />
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-foreground">{title}</h1>
          <p className="text-sm text-muted-foreground">
            An unexpected error occurred. You can try reloading the page or return to your dashboard.
          </p>
        </div>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Button onClick={() => { navigate("/dashboard"); setTimeout(() => window.location.reload(), 50); }}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RouteErrorFallback;